/**
 * @private
 */
var b2DynamicTreePair = /** @class */ (function () {
    function b2DynamicTreePair() {
    }
    return b2DynamicTreePair;
}());
export { b2DynamicTreePair };
